"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Search_1 = __importDefault(require("@material-ui/icons/Search"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var BusinessList = __importStar(require("../ui/business/list"));
var paper_1 = __importDefault(require("../ui/paper"));
var link_1 = __importDefault(require("../ui/link"));
var def = function (urlPrefix) { return [
    {
        name: 'name',
        label: 'Name',
        filter: true,
        sort: true
    },
    {
        name: 'table',
        label: 'Action',
        render: function (x) { return (react_1["default"].createElement(link_1["default"], { to: urlPrefix + "/" + String(x.name) + "/detail" },
            react_1["default"].createElement(IconButton_1["default"], null,
                react_1["default"].createElement(Search_1["default"], { color: "primary" })))); }
    }
]; };
var MyList = function (_a) {
    var entities = _a.entities, _b = _a.urlPrefix, urlPrefix = _b === void 0 ? '' : _b;
    return (react_1["default"].createElement(paper_1["default"], null,
        react_1["default"].createElement(BusinessList.LS.List, { data: entities, def: def(urlPrefix), config: { sortAttribute: 'name', sortDescAsc: true } })));
};
exports["default"] = MyList;
